(function () {
  function escapeHtml(str) {
    return String(str || '')
      .replaceAll('&', '&amp;')
      .replaceAll('<', '&lt;')
      .replaceAll('>', '&gt;')
      .replaceAll('"', '&quot;')
      .replaceAll("'", '&#039;');
  }

  function init() {
    const select = document.getElementById('pickup-location');
    const cardsContainer = document.getElementById('pickup-location-cards');
    const searchInput = document.getElementById('pickup-location-search');
    const hiddenName = document.getElementById('pickup-location-name');
const hiddenAddress = document.getElementById('pickup-location-address');

    if (!select || !cardsContainer) return;

    // Locations JSON holen (ID-Varianten tolerant)
    const locationsScript =
      document.getElementById('pickup-locations-json') ||
      document.getElementById('pickup-location-json');

    // Map: id -> addressLine
    const addressMap = new Map();

    if (locationsScript) {
      try {
        const config = JSON.parse(locationsScript.textContent || '{}');
        const locations = config.locations || [];
        locations.forEach((loc) => {
          const addressLine = loc.address
            ? loc.address
            : [loc.street, [loc.zip, loc.city].filter(Boolean).join(' ')].filter(Boolean).join(', ');
          if (loc.id) addressMap.set(String(loc.id), addressLine);
        });
      } catch (e) {
        console.warn('[Pickup] pickup-locations-json ist kein gültiges JSON', e);
      }
    }

    function applyFilter() {
      const term = (searchInput?.value || '').trim().toLowerCase();
      const cards = cardsContainer.querySelectorAll('.pickup-location-card');
      cards.forEach((card) => {
        const hay = (card.dataset.search || '').toLowerCase();
        card.style.display = !term || hay.includes(term) ? '' : 'none';
      });
    }

    function updateSelected() {
      const val = select.value;
      cardsContainer.querySelectorAll('.pickup-location-card').forEach((el) => {
        el.classList.toggle('pickup-location-card--selected', el.dataset.value === val);
      });
    }

    function buildCards() {
      // Optionen aus dem Select (Quelle der Wahrheit)
      const options = Array.from(select.options).filter((o) => o.value);

      // Wenn noch keine Optionen da sind → nichts rendern, warten auf Observer
      if (!options.length) {
        cardsContainer.innerHTML = '';
        return;
      }

      cardsContainer.innerHTML = '';

      options.forEach((opt) => {
        const id = String(opt.value);
        const name = opt.textContent || id;
        const address = addressMap.get(id);

        const card = document.createElement('button');
        card.type = 'button';
        card.className = 'pickup-location-card';
        card.dataset.value = id;
        card.dataset.search = `${name} ${address || ''}`;

        card.innerHTML = `
          <div class="pickup-location-card__radio"></div>
          <div class="pickup-location-card__text">
            <div class="pickup-location-card__name">${escapeHtml(name)}</div>
            ${address ? `<div class="pickup-location-card__address">${escapeHtml(address)}</div>` : ``}
          </div>
        `;

        card.addEventListener('click', function () {
          if (hiddenName) hiddenName.value = name;            // Filialname
          if (hiddenAddress) hiddenAddress.value = address || ''; // Adresse (oder leer)

          if (select.value !== id) {
            select.value = id;
            select.dispatchEvent(new Event('change', { bubbles: true }));
          }
          updateSelected();
        });

        cardsContainer.appendChild(card);
      });

      updateSelected();
      applyFilter();
    }

    // Initial
    buildCards();

    // Wenn dein pickup.js später Optionen ins Select schreibt → automatisch neu bauen
    const observer = new MutationObserver(() => {
      buildCards();
    });
    observer.observe(select, { childList: true, subtree: true });

    // Filter live
    if (searchInput) {
      searchInput.addEventListener('input', applyFilter);
    }

    // Wenn Select sich ändert (auch durch anderes JS)
    select.addEventListener('change', updateSelected);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();